import type { RelicCollectionType } from '@/types/relic'
import { relicIcon } from '@/views/item/data'

export let relicCollection: RelicCollectionType = {}
export function setRelicData(data: RelicCollectionType) {
  relicCollection = data
}
export function getRelicName(id: number, count: number) {
  const relicInfo = relicCollection[id]
  count > 50 && (count = 50)
  return `${relicIcon[relicInfo.element]} ${relicInfo.name}${count > 0 ? `[${count}]` : ''}`
}
export function explainRelicIdList(relicIdList: number[]) {
  if (!relicIdList) return ''
  const res = relicIdList.map((item) => {
    const info = relicCollection[item]
    return `<span class="${info.quality}" ${info.changeAtkElement ? 'style="font-weight: bold"' : ''}>${info.name}</span>`
  })
  return res.join('、')
}
